import { isEqual, isUndefined, omitBy } from 'lodash';

export const isEqualIgnoreUndefined: typeof isEqual = (a, b) => isEqual(omitBy(a, isUndefined), omitBy(b, isUndefined));
